import "./style.css";
import { useState,useEffect } from "react";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Button, ThemeProvider, createTheme } from "@mui/material";
import ScrollToTop from '../../Components/scrollup'
import ScrollPage from "../../Components/scrollpageUp";
import { RealisationDetail } from "../../Data/cardData";
import parse from "html-react-parser";
import Footer from "../../Components/Footer";
import Skeleton from '@mui/material/Skeleton';
const customTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1080,
      lg: 1280,
    },
  },
  palette: {
    primary: {
      main: "#1976D2",
      light: "#1966D1",
      dark: "#1986D4",
      contrastText: "#fff",
    },
  },
});
export default function RealisationsDetails() {
  const [path1, setPath1] = React.useState('');
    React.useEffect(() => {
        let pathName = window.location.pathname;
        let pathe = pathName.replace(/%20/g, ' ');
        let newPath1 = pathe.split('/')[1];
        setPath1(newPath1);
      }, []);
      
   const settings2 = {
    slidesToShow: 1,
       slidesToScroll: 1, 
      autoplay: true,
    autoplaySpeed: 1800,
    dots: true,
    infinite: true,
    speed: 500,
    };

    const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 2000); // 1 seconde

    return () => clearTimeout(timer);
  }, []);
  return (
    <ThemeProvider theme={customTheme}>
      <div className="home">
        <ScrollToTop/>
        <ScrollPage/>
        {path1  && (
           !showImage ? (
        <Skeleton  sx={{ bgcolor: 'grey.900' }} variant="rectangular" width="100vw" height="50vh" />
      ) : (
  <div
    className="sousRealisationBack"
    style={{
      backgroundImage: `url(https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2FrealisationsDetails%2F${encodeURIComponent(path1)}%2F2.jpg?alt=media)`,
    }}
  >
    <div>
   
<h1> {decodeURIComponent(path1)}</h1>
</div>
  </div>)
)}
 {RealisationDetail.map((item, index) =>
              item.name === path1?(
                <div className="projectDetailsPage" >
                <div className="projectDetails" >
                  <div >
                  <h2>{item.title}</h2>
                     <p>{parse(item.descreption)}</p>
                      <a
                href="mailto:ellouzealumarketing@gmail.com"
             
              >
                     <Button size="small" variant="contained" sx={{marginLeft:'20px',fontFamily:'Poppins',fontSize:'12px'}}>Demander Devis</Button>
                   </a>
                     </div>
 <img  src={`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2FrealisationsDetails%2F${encodeURIComponent(path1)}%2Fcouverture.jpg?alt=media`}
  alt={path1} />
    
       </div>
       <div className="projetsSlider" >
               <Slider {...settings2}>
  {item.projets.map((pic) => (
    <div className="slider-item" key={pic}>
      <div className="slider-img-wrapper">
        <img
          src={`https://firebasestorage.googleapis.com/v0/b/saveurs-fatma.appspot.com/o/ellouzeAlu%2FrealisationsDetails%2F${encodeURIComponent(path1)}%2F${encodeURIComponent(pic)}.jpg?alt=media`}
          alt={item}
          className="slider-img"
        />
        <span >{item.title} </span>
      </div>
    </div>
  ))}
</Slider>

       </div>
       </div>
       ):(<></>))}
       <Footer/>
    </div>
      
    </ThemeProvider>
  );
}

